import { ParametroPaginacionGenerico } from "src/app/util/ParametroPaginacionGenerico";

export class FiltroPersonamast {
    criterio: string;
    busqueda: string;
    conPyme: string;
    buscarDentro: string;
    conInactivos: string;

    codigo: number;
    documentoFiscal: string;
    nombre: string;
    idVendedor: number;

    paginacion: ParametroPaginacionGenerico;

    constructor() {
        this.paginacion = new ParametroPaginacionGenerico();
        this.criterio = 'NOMBRE_CORTO';
        this.conPyme = null;
    }
}

